import { Injectable } from '@angular/core';
/*
  NumberHelper
  Do more with numbers
*/

// Class Definition
@Injectable()
export class NumberHelper {
  toDollarAmount(num: number, language: string, currency: string): string {
    return num.toLocaleString(language, { currency, style: 'currency' });
  }
}
